import React from 'react';
import { Result, Button } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Route -> i18n key
const PAGE_TITLE_KEY_MAP: Record<string, string> = {
  '/admin/analytics/dashboard': 'menu:dashboard',
  '/admin/analytics/reports': 'menu:reports',
};

const ComingSoonPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const pageTitle = PAGE_TITLE_KEY_MAP[location.pathname]
    ? t(PAGE_TITLE_KEY_MAP[location.pathname])
    : t('common:comingSoon.defaultFeature');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 200px)',
        padding: '40px',
      }}
    >
      <Result
        icon={<RocketOutlined style={{ color: '#52c41a' }} />}
        title={`${pageTitle} - ${t('common:comingSoon.titleSuffix')}`}
        subTitle={t('common:comingSoon.subtitle')}
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            {t('common:comingSoon.backToPrevious')}
          </Button>
        }
      />
    </div>
  );
};

export default ComingSoonPage;
